var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElectronics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Electronics",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 26.673,
    viewBox: "0 0 36 26.673",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38224",
    "data-name": "Path 38224",
    d: "M33.055,1.145a1.8,1.8,0,0,1,1.8,1.718V18.573H1.145V2.864A1.785,1.785,0,0,1,2.864,1.145ZM2.864,0A2.9,2.9,0,0,0,0,2.864V20.291a2.917,2.917,0,0,0,2.864,2.945h7.609v2.291H8.1v1.145H27.818V25.527H25.527V23.236h7.527A2.933,2.933,0,0,0,36,20.291V2.864A2.917,2.917,0,0,0,33.055,0ZM24.382,25.527H11.618V23.236H24.382Zm8.673-3.518H2.864a1.728,1.728,0,0,1-1.718-1.718v-.573H34.855v.573A1.747,1.747,0,0,1,33.055,22.009Z",
    fill: "#2b2a29",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectronics);
export default __webpack_public_path__ + "static/media/Electronics.c3ac0b89f7c931add75c59b844a61b75.svg";
export { ForwardRef as ReactComponent };